export const MD_ID_INTENT = 100000;
export const STEP_INTENT = 0;
export const STEP_ARGUMENTS = 1;
export const STEP_RESOLUTION = 2;
